import { AddBranchComponent } from "./add-branch/add-branch.component";
import { EditBranchComponent } from "./edit-branch/edit-branch.component";
import { ViewBranchComponent } from "./view-branch/view-branch.component";

export const BranchModuleDeclaration = [
    AddBranchComponent,
    EditBranchComponent,
    ViewBranchComponent
];